import React from "react";

const Faqsection = () => {
  const faqs = [
    {
      question: "What is synergy coin?",
      answer:
        "Synergy Coin (SCI) is a cryptocurrency that will be used as a currency in Synergy’s Marketplace website."
    },
    {
      question: "What’s the vision for Synergy Coin Inc?",
      answer:
        "Become a financial hub for our crypto community, and become the bridge from crypto to traditional financing. Become a Publicly Traded company on either the NYSE or Nasdaq."
    },
    {
      question: "What real world asset will Synergy coin hold in its Reserves?",
      answer:
        "Treasuries bills, gold, ETFs, other crypto assets, real estate and Government Bonds."
    },
    {
      question: "How could I use Synergy coin?",
      answer:
        "Users will be able to transact business on Synergy Marketplace using Synergy coin (SCI),Synergy coin Community Member could qualify for a Synergy coin visa/Mastercard.Synergy coin could be transfer to different exchange wallets to transfer to their banks or convert our coins to other crypto coin on listing exchanges."
    },
    {
      question: "Where could I buy Synergy Coin?",
      answer:
        "Synergy coin is privately held by synergy coin Inc. only presale purchases are available our websites.Once ITO is completed.Purchases can be made on these three exchanges Robinhood, Coinbase, Crypto.com"
    },
     {
      question: "When will Synergy crypto visa/mastercard program be available?",
      answer:
        "6 months after Synergy Coin’s ITO we plan to roll our our crypto card."
    },
    
  ];

  return (
    <section className="w-full relative bg-black overflow-hidden py-16">

      {/* Background Left Shape - Hidden on mobile */}
      <img
        src="images/leftstar.png"
        alt="Left Star"
        className="absolute left-0 top-20 opacity-90 w-48 sm:w-56 md:w-64 lg:w-72 brightness-110 hidden md:block"
      />

      {/* Background Right Shape - Hidden on mobile */}
      <img
        src="/images/faq-right.png"
        alt="Right Glow"
        className="absolute right-0 top-0 opacity-90 h-full w-auto max-w-none object-contain  hidden md:block"
      />

      <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-8 text-center">

        {/* Header */}
        <span className="inline-flex bg-transparent border border-[#A855F7] text-[#A855F7] px-4 sm:px-6 py-2 rounded-md text-xs sm:text-sm md:text-base mb-2">
          FAQs
        </span>
        <h2 className="text-white text-4xl sm:text-5xl md:text-6xl font-bold mb-4">
          Questions & Answers
        </h2>
        <p className="text-gray-400 max-w-2xl mx-auto text-sm sm:text-base">
          Be part of Synergy Coin’s early growth, secure discounted presale tokens, unlock referral rewards, and grow alongside a global crypto community.
        </p>

        {/* Cards Grid */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-10 px-4">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-gradient-to-br from-white/10 via-white/5 to-transparent
                         border border-white/20 rounded-xl p-7 backdrop-blur-xl
                         shadow-lg hover:shadow-purple-500/40 hover:scale-[1.03]
                         transition-all duration-300"
            >
              {/* Icon */}
              <div className="flex justify-center mb-5">
                <img src="images/Relume.png" alt="FAQ Icon" className="w-12 h-12" />
              </div>
              {/* Question */}
              <h3 className="text-white text-lg font-semibold mb-3">
                {faq.question}
              </h3>
              {/* Answer */}
              <p className="text-gray-300 text-sm">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faqsection;
